export class AboutInfo {
    productName!: string;
    companyName!: string;
    copyrights!: string;
  }